/* Naturbly dataLayer events — Fase 5
   Scope: scroll-depth, cta-clicks, phone/email/outbound, site-search
*/
(function() {
  if (!window.dataLayer) window.dataLayer = [];

  // Scroll depth 25/50/75/90
  var thresholds = [25, 50, 75, 90];
  var fired = {};
  window.addEventListener('scroll', function() {
    var pct = Math.round(
      (window.scrollY + window.innerHeight) /
      document.documentElement.scrollHeight * 100
    );
    thresholds.forEach(function(t) {
      if (pct >= t && !fired[t]) {
        fired[t] = true;
        window.dataLayer.push({ event: 'scroll_depth', percent_scrolled: t });
      }
    });
  }, { passive: true });

  // CTA / phone / email / outbound click tracking
  document.addEventListener('click', function(e) {
    var a = e.target.closest('a, button');
    if (!a) return;
    if (a.href && a.href.indexOf('tel:') === 0) {
      window.dataLayer.push({ event: 'phone_click', link_url: a.href }); return;
    }
    if (a.href && a.href.indexOf('mailto:') === 0) {
      window.dataLayer.push({ event: 'email_click', link_url: a.href }); return;
    }
    if (a.href && a.hostname && a.hostname !== location.hostname) {
      window.dataLayer.push({ event: 'outbound_click', link_url: a.href }); return;
    }
    var text = (a.innerText || '').trim().slice(0, 120);
    var role = a.getAttribute('data-cta') || (a.classList.contains('btn') ? 'button' : null);
    if (role && text) {
      window.dataLayer.push({
        event: 'cta_click',
        button_text: text,
        cta_role: role,
        page_path: location.pathname
      });
    }
  });

  // Site search
  document.addEventListener('submit', function(e) {
    var form = e.target;
    if (form.action && form.action.indexOf('/search') !== -1) {
      var input = form.querySelector('input[name="q"]');
      if (input && input.value) {
        window.dataLayer.push({ event: 'site_search', search_term: input.value });
      }
    }
  });

  // Cart-add via ecommerce event
  window.addEventListener('nb-cart-updated', function(e) {
    if (e.detail && e.detail.items) {
      window.dataLayer.push({
        event: 'cart_updated',
        cart_item_count: e.detail.item_count,
        cart_total: e.detail.total_price / 100
      });
    }
  });
})();
